import { EventEmitter, Injectable, Output } from '@angular/core';

import { SalesFilter } from '../../../shared/models/metrics/salesFilter';
import { RolType } from '../../../shared/models/types/rol.types';
import { AuthService } from '../../../shared/services/security/auth.service';

@Injectable()
export class SalesComunicationService {

  @Output() readonly filter: EventEmitter<any> = new EventEmitter();
  rolType: RolType = new RolType();

  public constructor(private readonly authService: AuthService) {
  }

  applyFilter(filter: SalesFilter, filterForTable: any): void {
    this.filter.emit({ filter, filterForTable });
  }

}
